export default __webpack_public_path__ + "static/media/templates.6847dbc2.svg";